import { useEffect } from 'react';
import { Actions, PageController } from '@sitecore-search/core';
import useBaseWidget from './useBaseWidget.js';
import useWidget from './useWidget.js';
import { useHandlerRef } from './utils.js';
const requestResponseReducer = (state, action) => {
    switch (action.type) {
        case Actions.WIDGET_DATA_REQUEST_SUCCESS: {
            const { response } = action.payload;
            return {
                ...state,
                response,
            };
        }
        case Actions.WIDGET_DATA_REQUEST: {
            const { request } = action.payload;
            return {
                ...state,
                request,
            };
        }
        default:
            return state;
    }
};
const useWidgetActionsReducer = (reducer, deps) => {
    const control = useWidget();
    const { rfkId, instanceId } = useBaseWidget();
    const actionReducer = useHandlerRef(reducer, deps);
    useEffect(() => {
        const listener = {
            handleAction(action) {
                const { rfkId: id, instanceId: instance = null } = action.payload;
                if (id === rfkId && instanceId === instance) {
                    const newState = actionReducer.current(requestResponseReducer(control.state, action), action);
                    if (newState !== control.state) {
                        control.updateState(newState);
                    }
                }
            },
        };
        PageController.register(listener);
        return () => PageController.unregister(listener);
    }, [rfkId, instanceId, control, actionReducer]);
};
export default useWidgetActionsReducer;
